import Column from '@components/Column';
import SortableItem from '@components/Draggable/SortableItem';
import {
    DndContext, DragEndEvent, DragStartEvent, UniqueIdentifier,
} from '@dnd-kit/core';
import { arrayMove, SortableContext } from '@dnd-kit/sortable';
import { ReactNode, useState } from 'react';

interface Props {
    children: ReactNode[];
    spacing?: number;
    className?: string;
}
function Draggable({ children, spacing, className }:Props) {
    const [order, setOrder] = useState<string[]>(Array.from({ length: children.length }, (_, i) => i.toString()));
    const [activeId, setActiveId] = useState<UniqueIdentifier|undefined>();

    const handleDragStart = ({ active }: DragStartEvent) => {
        setActiveId(active.id);
    };
    const handleDragEnd = ({ over }:DragEndEvent) => {
        if (over && activeId) {
            const activeIndex = order.indexOf(activeId.toString());
            const overIndex = order.indexOf(over.id.toString());
            setOrder(arrayMove(order, activeIndex, overIndex));
        }
    };
    return (
        <DndContext onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}>
            <Column fullWidth spacing={spacing} className={className}>
                <SortableContext items={order}>
                    {children.map((child, i) => (
                        <SortableItem id={i.toString()} key={`sortable ${i}`}>
                            {child}
                        </SortableItem>
                    ))}
                </SortableContext>
            </Column>
        </DndContext>
    );
}

export default Draggable;
